import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import UserManagement from './components/UserManagement';
import UserEnquiries from './components/UserEnquiries';
import AIFeedback from './components/AIFeedback';
import Integrations from './components/Integrations';
import Webhooks from './components/Webhooks';
import Recordings from './components/Recordings';
import ChatHistory from './components/ChatHistory';
import AWSS3 from './components/AWSS3';
import Trengo from './components/Trengo';
import Settings from './components/Settings';
import Sidebar from './components/Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.scss';

const AppContent = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <div className="app-container">
      <Sidebar />
      <div className="main-content">
        <div className="content-wrapper">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/user-enquiries" element={<UserEnquiries />} />
            <Route path="/ai-feedback" element={<AIFeedback />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/webhooks" element={<Webhooks />} />
            <Route path="/recordings" element={<Recordings />} />
            <Route path="/chats" element={<ChatHistory />} />
            <Route path="/aws-s3" element={<AWSS3 />} />
            <Route path="/trengo" element={<Trengo />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App; 